import { pushEvent } from 'src/client/data-layer';

export const trackSearchSuggestionsListed = () => {
  pushEvent('searchSuggestionsListed');
};

export const trackSearchSuggestionClicked = (
  type: string,
  suggestion: string
) => {
  pushEvent('searchSuggestionClicked', { type, suggestion });
};

export const trackSearchHistoryListed = () => {
  pushEvent('searchHistoryListed');
};

export const trackSearchHistoryClicked = (title?: string) => {
  pushEvent('searchHistoryClicked', { title });
};

export const trackSearchHistoryDeleted = (title?: string) => {
  pushEvent('searchHistoryDeleted', { title });
};
